import { DateTimeTz } from "@web-app/components";
import { AppFilterType } from "@web-app/types";

import Pill from "./Pill";

export default function Pills({
  appFilter,
  assigneeCount,
  connectionCount,
  deliveryTypeCount,
  formattedText,
  isDateRange,
  onChange,
  openAppFilterPopover,
  statusCount,
  temporaryAppFilter,
}: {
  appFilter: AppFilterType;
  assigneeCount: number;
  connectionCount: number;
  deliveryTypeCount: number;
  formattedText: (count: number, text: string) => string;
  isDateRange?: boolean;
  onChange: (data: Partial<AppFilterType>, apply?: boolean) => void;
  openAppFilterPopover: (index: number) => void;
  statusCount: number;
  temporaryAppFilter: AppFilterType;
}) {
  return (
    <div className="flex items-stretch gap-2">
      <Pill
        onClick={() => openAppFilterPopover(0)}
        isClosable={false}
        data-testid="date-filter-pill"
      >
        <DateTimeTz
          presentation="pill"
          start={new Date(appFilter.scheduledDateTimeStart)}
          end={new Date(appFilter.scheduledDateTimeEnd)}
          isDateRange={isDateRange}
        />
      </Pill>
      {!!statusCount && (
        <Pill
          onClick={() => openAppFilterPopover(1)}
          onClose={() => {
            onChange(
              {
                ...temporaryAppFilter,
                driverStatus: [],
                orderStatus: [],
              },
              true,
            );
          }}
        >
          {statusCount} Status
        </Pill>
      )}
      {!!deliveryTypeCount && (
        <Pill
          onClick={() => openAppFilterPopover(2)}
          onClose={() =>
            onChange(
              {
                ...temporaryAppFilter,
                orderDeliveryType: [],
              },
              true,
            )
          }
        >
          {formattedText(deliveryTypeCount, "Type")}
        </Pill>
      )}
      {!!assigneeCount && (
        <Pill
          onClick={() => openAppFilterPopover(3)}
          onClose={() =>
            onChange(
              {
                ...temporaryAppFilter,
                assigneeIds: [],
              },
              true,
            )
          }
        >
          {formattedText(assigneeCount, "Assignee")}
        </Pill>
      )}
      {!!connectionCount && (
        <Pill
          onClick={() => openAppFilterPopover(4)}
          onClose={() =>
            onChange(
              {
                ...temporaryAppFilter,
                workspaceIds: [],
              },
              true,
            )
          }
        >
          {connectionCount} Connections
        </Pill>
      )}
    </div>
  );
}
